export default {
  title: {
    create: 'Рассылка',
    templates: 'Шаблоны',
    payment: 'Баланс',
    support: 'Поддержка',
    jivosite: 'Поддержка'
  }
}
